import axios from "axios";
import { STRIPE_ENDPOINT } from "./APIEndpoints";
axios.defaults.withCredentials = true;
export const getProducts = async (params) => {
  try {
    const res = await axios.get(STRIPE_ENDPOINT+'/products', params);
    return res.data;
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const getPriceById = async (id) => {
  try {
    const res = await axios.get(`${STRIPE_ENDPOINT}/prices/${id}`);
    return res.data;
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const createCheckoutSession = async ( mozzazCustomerID, stripeCustomerId, priceID, productName, checkoutMode, ORGID, token) => {
  try {
    const res = await axios.post(`${STRIPE_ENDPOINT}/checkoutsessions`, { mozzazCustomerID, stripeCustomerId, priceID, productName, checkoutMode, ORGID, token});
    return res.data;
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const createPortalSession = async (CustomerId) => {
  try {
    const res = await axios.post(`${STRIPE_ENDPOINT}/portalsessions`, {CustomerId});
    return res.data;
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const createCheckoutPaymentMethod = async (mozzazCustomerID) => {
  try {
    const res = await axios.post(`${STRIPE_ENDPOINT}/checkoutpaymentmethodsessions`, {mozzazCustomerID});
    return res.data;
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const cancelSubscription = async (subscriptionid) => {
  try {
    const res = await axios.delete(`${STRIPE_ENDPOINT}/subscriptions/${subscriptionid}`);
    return res.data;
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};